import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import OrdersPage from './pages/OrdersPage';
import ProductsPage from './pages/ProductsPage';
import CustomersPage from './pages/CustomersPage';
import SettingsPage from './pages/SettingsPage';

function App() {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const checkAdminSession = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/admin/auth/me', {
        method: 'GET',
        credentials: 'include'
      });
      const payload = await response.json();
      if (response.ok && payload.authorized) {
        setAuthorized(true);
        setCurrentUser(payload.user || null);
      } else {
        setAuthorized(false);
        setCurrentUser(null);
      }
    } catch (_error) {
      setAuthorized(false);
      setCurrentUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAdminSession();
  }, []);

  const handleLoginSuccess = (user) => {
    setAuthorized(true);
    setCurrentUser(user || null);
  };

  const handleLogoutSuccess = () => {
    setAuthorized(false);
    setCurrentUser(null);
  };

  if (loading) {
    return <div className="auth-shell">Проверка сессии администратора...</div>;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          authorized ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <LoginPage onLoginSuccess={handleLoginSuccess} />
          )
        }
      />
      <Route
        path="/"
        element={
          authorized ? (
            <Layout currentUser={currentUser} onLogoutSuccess={handleLogoutSuccess} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="offers" element={<ProductsPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="payouts" element={<OrdersPage />} />
        <Route path="orders" element={<Navigate to="/payouts" replace />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to={authorized ? '/dashboard' : '/login'} replace />} />
    </Routes>
  );
}

export default App;